// 1. Utilitaires pour initialiser les données du formulaire
// utils/consultationUtils.ts
import type { FormData, Constante } from "../types/consultation";

export const initializeFormData = (constanteData?: Constante): FormData => {
  const patient: Partial<FormData["patientInfo"]> = constanteData?.patient || {};

  return {
    patientInfo: {
      nom:
        (patient as any).lastName ||
        constanteData?.patientFullName?.split(" ").pop() ||
        "",
      prenom:
        (patient as any).firstName ||
        constanteData?.patientFullName?.split(" ").slice(0, -1).join(" ") ||
        "",
      dateNaissance: (patient as any).dateOfBirth || (patient as any).dateNaissance || constanteData?.patientBirthDate || "",
      telephone: (patient as any).phone || "",
      adresse: (patient as any).address || "",
      motifConsultation: constanteData?.reason || "",
      dateConsultation: constanteData?.recordedAt
        ? new Date(constanteData.recordedAt).toISOString().split("T")[0]
        : new Date().toISOString().split("T")[0],
      sexe: (patient as any).gender || "",
      email: (patient as any).email || "",
      dureeSymptomes: "", // ✅ Ajouté
      allergies: "", // ✅ Ajouté
    },
    conditionsMedicales: {
      hypertensionArterielle: false,
      maladieCardiaque: false,
      cholesterolEleve: false,
      avc: false,
      diabete: false,
      maladieThyroidienne: false,
      drepanocytose: false,
      neurologique: false,
      toux: false,
      douleursMammaires: false,
      anomalieUterine: false,
      respirationSifflante: false,
      maladiesInfectieuses: false,
      tuberculose: false,
      asthme: false,
      arthrite: false,
      cancer: false,
      anemie: false,
      defautGenetique: false,
      sinusite: false,
      vertige: false,
      problemesMentaux: false,
      allergie: false,
      chirurgieGyneco: false,
      infertilite: false,
      vih: false,
      cyclesIrreguliers: false,
      fatigue: false,
      autre: "",
    },
    medicaments: "",
    dateDernierBilan: "",
    vieSociale: {
      animauxMaison: false,
      genreAnimaux: "",
      fumeur: false,
      cigarettesParJour: "",
      fumeurMaison: false,
    },
    antecedentsFamiliaux: {
      hypertensionArterielle: false,
      maladieCardiaque: false,
      cholesterolEleve: false,
      avc: false,
      diabete: false,
      maladieThyroidienne: false,
      drepanocytose: false,
      asthme: false,
      arthrite: false,
      cancer: false,
      retardMental: false,
      defautGenetique: false,
      sinusite: false,
      vertige: false,
      autre: false,
    },
    observationsSystemes: {
      fatigue: false,
      malNutrition: false,
      pertePoids: false,
      fievresRecurrentes: false,
      difficulteMarcher: false,
      hyperactivite: false,
      ecoulementOculaire: false,
      infectionsOreilleChroniques: false,
      sangUrine: false,
      myopie: false,
      depression: false,
      douleurAbdominale: false,
      problemesAudition: false,
      mauxGorge: false,
      vertiges: false,
      anxiete: false,
      ganglionsLymphatiques: false,
      congestionChronique: false,
      insomnie: false,
      sangMucus: false,
      ecoulementNasal: false,
      anemie: false,
      douleurPoitrine: false,
      essoufflement: false,
      nauseesVomissements: false,
      diarrheeConstipation: false,
      douleursMusculaires: false,
      autre: false,
    },
    consultationActuelle: {
      date: new Date().toISOString().split("T")[0],
      observations: "",
      recommandations: "",
      diagnostics: "",
      traitements: "",
    },
    poids: constanteData?.weight?.toString() || "",
    taille: constanteData?.height?.toString() || "",
    tensionArterielle: constanteData?.bloodPressure || "",
    rythmeCardiaque: constanteData?.heartRate?.toString() || "",
    temperature: constanteData?.temperature?.toString() || "",
  };
};
